(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cover-item"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cover-item').forEach(function (item) {
    var link = item.querySelector('.cover-item__link');
    var cartBtn = item.querySelector('.cover-item__cart');

    cartBtn.addEventListener('click', function (event) {
      event.preventDefault();

      var variantId = cartBtn.getAttribute('data-variant-id');
      var originalLabel = cartBtn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          cartBtn.textContent = cartBtn.dataset.addedLabel || originalLabel;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            cartBtn.textContent = originalLabel;
          }, 1500);
        });
    });

    if (window.matchMedia('(hover: hover)').matches) {
      return;
    }

    link.addEventListener('click', function (event) {
      if (!item.classList.contains('is-open')) {
        event.preventDefault();
        document.querySelectorAll('.cover-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
          }
        });
        item.classList.add('is-open');
      }
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.cover-item.is-open').forEach(function (item) {
      if (!item.contains(event.target)) {
        item.classList.remove('is-open');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["imprint-backgrounds"] && !Shopify.designMode) return;
  try {
    function positionImprintBands() {
    document.querySelectorAll('.imprint-band').forEach(function (band) {
      var imprint = band.getAttribute('data-imprint-band');
      var hero = document.querySelector('[data-imprint-hero="' + imprint + '"]');
      var explore = document.querySelector('[data-imprint-explore="' + imprint + '"]');

      if (!hero || !explore) {
        band.style.display = 'none';
        return;
      }

      band.style.display = '';

      var top = hero.getBoundingClientRect().bottom + window.scrollY;
      var bottom = explore.getBoundingClientRect().bottom + window.scrollY;

      band.style.top = top + 'px';
      band.style.height = Math.max(0, bottom - top) + 'px';
    });
  }

  window.addEventListener('load', positionImprintBands);
  window.addEventListener('resize', positionImprintBands);
  document.addEventListener('shopify:section:load', positionImprintBands);
  document.addEventListener('DOMContentLoaded', positionImprintBands);

  // Google Fonts are loaded with display=swap (see layout/theme.liquid), so
  // page text first renders in a fallback font and swaps to the real one
  // later, without blocking `load` — the swap changes line lengths/heights
  // in .explore's text, which can grow the imprint's total height after
  // the band above was already sized against the shorter fallback-font
  // layout. Re-measuring once fonts are actually ready closes that gap.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(positionImprintBands);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-card__form').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('.product-card__cart');
      var variantId = form.querySelector('input[name="id"]').value;
      var originalLabel = button.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          button.textContent = button.dataset.addedLabel || originalLabel;
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            button.textContent = originalLabel;
          }, 1500);
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
